import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { useState } from 'react'
import type { TempoSyncPreview } from '~/api/queries/order'
import { inlineListItem, optionItemChevron } from '../AccountingInputs.css'
import {
  itemHeader,
  itemWrapper,
  previewBody,
  previewBodyInner,
  previewBodyOpen
} from './TempoSyncPreviewItem.css'
import { TempoSyncPreviewSection } from './TempoSyncPreviewSection'

type Props = {
  label: string
  statusText: string
  preview?: TempoSyncPreview | null
}

export const TempoSyncPreviewItem = ({ label, statusText, preview }: Props) => {
  const [open, setOpen] = useState(false)

  if (preview == null) {
    return (
      <div className={inlineListItem}>
        {label} <strong>{statusText}</strong>
      </div>
    )
  }

  return (
    <div className={itemWrapper}>
      <button
        type="button"
        className={itemHeader}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        {label} <strong>{statusText}</strong>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={clsx(optionItemChevron, open ? 'expanded' : null)}
        />
      </button>
      <div className={clsx(previewBody, open ? previewBodyOpen : null)}>
        <div className={previewBodyInner}>
          <TempoSyncPreviewSection preview={preview} />
        </div>
      </div>
    </div>
  )
}
